
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandY as ObiOwnShipNoCommandYElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-y.js';
 
 
 

 
 export const ObiOwnShipNoCommandY = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-y',
   elementClass: ObiOwnShipNoCommandYElement,
   events: {
     
   }
  });
 
 